<template>
  <div class="orderlist-main">
    <van-tabs color="#2283E2" :active="active" @click="tabGetList">
      <van-tab
        :title="item.name"
        v-for="(item, index) in cards"
        :name="item.status"
        :key="index"
      >
        <van-list
          :loading="loading"
          :finished="complated"
          :total="total"
          finished-text="没有更多了"
          @load="onLoad"
          :immediate-check="false"
        >
          <orderGoods
            @getOrderList="orderItemReload()"
            @deliver="deliver()"
            :orderList="orderList"
          ></orderGoods>
        </van-list>
        <div v-if="moreShow">
          <div class="order" style="border: 1px #666 solid" @click="getMoreList()">
            更多积分商城订单
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import orderGoods from "@/components/orderGoods.vue";
import { getOrdersList } from "@/api/api";

export default {
  components: {
    orderGoods: orderGoods,
  },
  data() {
    return {
      active: "",
      cards: [
        {
          name: "全部",
          status: "",
        },
        {
          name: "待支付",
          status: "1",
        },
        {
          name: "待发货",
          status: "7",
        },
        {
          name: "已发货",
          status: "8",
        },
        {
          name: "已签收",
          status: "9",
        },
        {
          name: "已完成",
          status: "10",
        },
        
        // {
        //     name: "待审核",
        //     status: "4"
        // },
        // {
        //     name: "审核拒绝",
        //     status: "5"
        // },
      ],
      complated: false,
      loading: false,
      finished: false,
      activeName: "0",
      orderList: [],
      total: "",
      type: "",
      pageNum: 1,
      timer: "",
      oldArray:[],
      moreList: [],
      moreShow: false,
    };
  },

  methods: {
    onLoad() {
      if (!this.loading) {
        this.loading = true; //证明正在加载中 阻断 调用onLoad
        this.getOrdersList(); //反向loading 没在加载中 可以进入
      }
    },
    orderListInit() {
      //获取所有订单
      this.type = null
      this.getOrdersList();
    },
    lastYear() {
      var dt = new Date();
      dt.setFullYear(dt.getFullYear() - 1);
    //   console.log(dt);
      return dt;
    },
    async getOrdersList() {
      const hbscToken =
        this.$cookies.get("hbscToken") ||
        sessionStorage.getItem("hbscToken") ||
        "";
      const memberId =
        this.$cookies.get("memberId") ||
        sessionStorage.getItem("memberId") ||
        "";
      if (!hbscToken || !memberId) {
        this.complated = true;
        this.loading = false; //关闭加载
        return;
      }
      let params = {
        // "memberId": "100",
        // "orderNo": "",
        pageNum: this.pageNum,
        pageSize: 10,
        // startTime: this.lastYear(),
        // endTime: new Date(),
        //"status": 0
      };
      if (this.type != 0) {
        params.status = this.type;
      }
      if (this.$route.query.sources!=null) {
        params.sources = this.$route.query.sources;
      }

      let res = await getOrdersList(params);
      if (res.code == "0000") {
        if (res.result == null) {
          if (this.pageNum != 1) {
            this.loading = false; //关闭加载
            this.complated = true;
            return;
          }
          this.orderList = [];
          this.total = 0;
          this.complated = true;
          this.loading = false; //关闭加载
        } else {
          if (res.result.pageNum != this.pageNum) {
            //返回的当前页与传入的当前页不符合 证明存在重复加载的嫌疑
            this.pageNum = res.result.pageNum + 1;
            return false;
          }
          this.oldArray = []
          res.result.list.forEach((item, index) => {
            if(new Date(item.orderCreate.replace(/-/g,'/')) > this.lastYear()){
              this.oldArray.push(item)
            }else{
              this.moreList.push(item)
              this.moreShow = true
            }
          });
          this.orderList = this.orderList.concat(this.oldArray); //拼接查询结果
          this.total = res.result.total; //获取最大条数
          if (this.pageNum * params.pageSize > res.result.total) {
            //如果当前页和每页显示条数大于total证明查询结果不够12条 显示没有更多 否则 不显示
            this.complated = true;
          } else {
            this.complated = false;
          }
          this.pageNum = this.pageNum + 1; //当前页加一
          this.loading = false; //关闭加载
        }
      } else {
        this.complated = true;
        this.loading = false; //关闭加载
      }
    },
    tabGetList(name, title) {
      console.log(name, title);
      this.orderList = [];
      this.oldArray =[]
      this.moreList = []
      this.moreShow=false
      this.pageNum = 1;
      this.type = name;
      this.getOrdersList(name);
    },
    orderItemReload() {
      this.pageNum = 1;
      this.type = 9;
      this.orderList = [];
      this.active = "9";
      this.getOrdersList(this.type, this.pageNum);
    },
    deliver() {
      this.pageNum = 1;
      this.type = 7;
      this.orderList = [];
      this.active = "7";
      this.getOrdersList(this.type, this.pageNum);
      // debugger;
    },
    getMoreList(){
       this.orderList = this.orderList.concat(this.moreList)
       this.moreShow = false
       this.moreList=[]
    }
  },
  mounted() {
    if (!this.timer) {
      this.timer = setInterval(() => {
        const hbscToken =
          this.$cookies.get("hbscToken") ||
          sessionStorage.getItem("hbscToken") ||
          "";
        const memberId =
          this.$cookies.get("memberId") ||
          sessionStorage.getItem("memberId") ||
          "";
        if (hbscToken || memberId) {
          clearInterval(this.timer);
          this.orderListInit();
        }
      }, 1000);
    }
    //     this.orderListInit()
  },
};
</script>

<style lang="scss" scoped>
.paging {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.order {
  width: 240px;
  height: 45px;
  line-height: 45px;
  border: 1px #666 solid;
  border-radius: 20px;
  text-align: center;
  margin: auto;
  padding: 2px;
  margin-top: 10px;
}
</style>
